import BlogLastArticle from './blogLastArticle'

export default BlogLastArticle